<div class="flex-container gap-6" style="height: 100%">
  <div class="flex-col" style="gap: 1px">
    <vl-widget-title
      [text]="'stats.ca_par_periode' | trans"
      [accent]="accentLabel()"
      [widget]="widget()"
      [draggable]="!!widget()"
      [editable]="false"
      [filter]="true"
    >
      <ng-content class="drag-handler" select=".drag-handler"></ng-content>

      <vl-chips-toggle
        [value]="timeScale()"
        [elements]="timeScaleChoices"
        (valueChange)="timeScale.set($event)"
        size="small"
      />

      <div class="filter">
        <vl-chips
          size="small"
          iconLeft="settings"
          (action)="trigger.attachOverlay()"
          [popoverTrigger]="filters"
          #trigger="popoverElement"
          [closeOnClickOutside]="true"
          state="enabled"
        >
          {{ 'button.filter' | trans }}
        </vl-chips>
      </div>
    </vl-widget-title>

    <!-- Légende compacte sous le titre -->
    @if (totalCA()) {
      <div class="legend-row caption on-background-alt" style="padding-left: 2px">
        <span class="leg-item">
          <span class="dot dot-ca"></span> CA
        </span>
        <span class="leg-item">
          <span class="dot dot-cost"></span> Coût
        </span>
        <span class="leg-item">
          <span class="dot dot-marge"></span> Marge
          <span [class]="pctClass()" style="font-weight: 600; margin-left: 4px">
            {{ (totalMarginPct() * 100) | number:'1.1-1' }} %
          </span>
        </span>
      </div>
    }
  </div>

  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3" style="min-width: 220px">
      <div class="caption on-background">Filtrer par article</div>
      <vl-select-autocomplete
        [options]="articlesOptions()"
        [value]="selectedArticleId()"
        (valueChange)="selectedArticleId.set($event)"
      />
    </div>
  </ng-template>

  @if (metadata()?.loading) {
    <div class="overflow-hidden widget-content">
      <div class="flex-row gap-16 align-end">
        @for (i of [0, 1, 2, 3, 4, 5]; track i) {
          <ngx-skeleton-loader
            count="1"
            [theme]="{ 'height': (80 + (i * 25)) + 'px', 'width': '50px', 'background-color': 'var(--color-on-disabled)' }"
          />
        }
      </div>
    </div>
  } @else if (labels().length) {
    <div class="widget-body fade-in">
      <div class="chart-wrap">
        <canvas #c></canvas>
      </div>
      <div class="flex-row justify-end">
        <vl-chips
          state="active"
          size="small"
          iconRight="open_in_new"
          (action)="openFullList()"
        >
          {{ 'button.see_all' | trans }}
        </vl-chips>
      </div>
    </div>
  } @else {
    <div class="widget-content empty">
      <div class="caption on-disabled">{{ 'filters.no_data' | trans }}</div>
    </div>
  }
</div>
